(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eco-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('eco-spotlight-media')) {
    customElements.define('eco-spotlight-media', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.visible = false;
        this.sync = () => {
          if (this.visible && !document.hidden) {
            if (this.video.paused) this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        };
        this.onPlaying = () => {
          if (!this.visible || document.hidden) this.video.pause();
        };
        this.video.addEventListener('playing', this.onPlaying);
        document.addEventListener('visibilitychange', this.sync);
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
          this.sync();
        }, { threshold: [0, 0.25] });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('visibilitychange', this.sync);
        this.video?.removeEventListener('playing', this.onPlaying);
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
